module.exports = __webpack_public_path__ + "static/media/lead.6ef8fb51.svg";